import React from 'react';
import {DashboardNavigationTopBar} from '../dashboard/DashboardNavigationTopBar';
import {CouponRoutes} from './CouponRoutes';
import css from './CouponNavigation.module.css';

export const CouponNavigation = () => {
  return (
    <div className={css.navigationWrapper}>
      <DashboardNavigationTopBar isPublic />
      <CouponRoutes />
    </div>
  );
};
